import React from 'react';

import multiLineInput from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/multiLineInput/models/schemaShape';
import options from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/options/models/schemaShape';
import singleLineInput from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/singleLineInput/models/schemaShape';
import yesNo from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/yesNo/models/schemaShape';

// @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
export default React.PropTypes.oneOfType([multiLineInput, options, singleLineInput, yesNo]);
